import { Permissions } from "@/jenesys-types/jenesys-entities/permissions";

import { useCompany } from "./useCompany";

export const useRoles = () => {
  const { selectedCompany } = useCompany();

  const userCan = (action: keyof typeof Permissions) =>
    Permissions[action].includes(selectedCompany?.role as never);

  const userCannot = (action: keyof typeof Permissions) =>
    !Permissions[action].includes(selectedCompany?.role as never);

  return {
    userCan,
    userCannot,
    isAdmin:
      selectedCompany?.role === "SUPER_ADMIN" ||
      selectedCompany?.role === "PRACTICE_ADMIN" ||
      selectedCompany?.role === "DAO_ADMIN",
    isBasicUser:
      selectedCompany?.role === "COMPANY_USER" ||
      selectedCompany?.role === "COMPANY_ADMIN" ||
      selectedCompany?.role === "DAO_USER"
  };
};
